import { render } from "./SkyTableColumn.vue?vue&type=template&id=070ca372"
import script from "./SkyTableColumn.vue?vue&type=script&lang=js"
export * from "./SkyTableColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__